export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                // {
                //     title: 'Tipo',
                //     type: 'custom-html',
                //     key: 'establishment_type',
                //     modifier: (value) => {
                //         return value == 'B' ? 'LOCALES U OFICINAS NO CRITICAS' : 'UNIDADES TÉCNICAS';
                //     }
                // },
                {
                    title: "Nombre",
                    type: 'text',
                    key: 'name',
                },
                {
                    title: "Responsable",
                    type: 'text',
                    key: 'legal_representative',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}